import { Helmet } from "react-helmet";

export function Seo() {
  return (
    <Helmet>
      <title>Alquiler de Quincho en Caacupé</title>
      <meta
        name="description"
        content="Quincho ideal para reuniones familiares, amigos y eventos especiales. Capacidad hasta 20 personas. Ubicado en Caacupé, Paraguay."
      />
      <meta name="keywords" content="quincho, alquiler, Caacupé, reuniones, karaoke, eventos" />
      <meta property="og:title" content="Alquiler de Quincho en Caacupé" />
      <meta property="og:description" content="Ideal para reuniones y celebraciones, con karaoke, proyector y más." />
      <meta property="og:image" content="https://tusitio.com/img/quincho/quincho1-large.jpg" />
      <meta property="og:type" content="website" />
    </Helmet>
  );
}